import { Subject } from 'rxjs';

import { OnDestroy, Component, ChangeDetectionStrategy, ViewContainerRef } from '@angular/core';

import { SnDrawerService } from '@lib/ui/drawer';

import { DebugPanelRegistryService } from '../services';
import { DebugPanelComponent } from './debug-panel.component';

@Component({
  selector: 'fs-debug-panel-button',
  templateUrl: './debug-panel-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DebugPanelButtonComponent implements OnDestroy {
  public isRootRoute = true;
  public canNavigationBack = false;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private _drawer: SnDrawerService,
    private _viewContainerRef: ViewContainerRef,
    private _debugPanelRegistryService: DebugPanelRegistryService,
  ) {}

  public get visible(): boolean {
    return this._debugPanelRegistryService.isEnabled;
  }

  public onClick(): void {
    if (this._drawer.has('debug-panel')) {
      this._drawer.close('debug-panel');
      return;
    }
    this._drawer.open(DebugPanelComponent, {
      id: 'debug-panel',
      width: 402,
      hasBackdrop: true,
      position: 'right',
      mode: 'side',
      panelClass: 'debug-panel-form-drawer',
      viewContainerRef: this._viewContainerRef, // Pass the ViewContainerRef to inherit the correct injector
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
